import Axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

export class HttpService {
  _axios = Axios.create({
    baseURL: API_URL
  });

  addRequestInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.response.use(onFulfilled, onRejected);
  };

  get = async (url, config = {}) => await this.request(this.getOptionsConfig("get", url, null, config));

  post = async (url, data, config = {}) => await this.request(this.getOptionsConfig("post", url, data, config));

  put = async (url, data, config = {}) => await this.request(this.getOptionsConfig("put", url, data, config));

  patch = async (url, data, config = {}) => await this.request(this.getOptionsConfig("patch", url, data, config));

  delete = async (url, data, config = {}) => await this.request(this.getOptionsConfig("delete", url, data, config));

  download = async (url, data) => await this.request(this.getDownloadOptionsConfig("post", url, data));

  getOptionsConfig = (method, url, data, customConfig = {}) => {
    return {
      method,
      url,
      data,
      headers: {
        "Content-Type": "application/vnd.api+json",
        "Accept": "application/vnd.api+json",
        'Access-Control-Allow-Credentials': true,
        ...customConfig.headers
      },
      ...customConfig
    };
  };

  // ✅ New configuration for file downloads
  getDownloadOptionsConfig = (method, url, data) => {
    return {
      method,
      url,
      data,
      headers: { "Content-Type": "application/vnd.api+json", 'Access-Control-Allow-Credentials': true },
      responseType: 'blob', // Crucial: Tells Axios to handle the response as a binary file
    };
  };

  request(options) {
    return new Promise((resolve, reject) => {
      this._axios
        .request(options)
        .then((res) => resolve(res.data))
        .catch((ex) => reject(ex.response?.data || ex));
    });
  }
}

export default new HttpService();